import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ENTERPRISE_CARD_NAME } from '../../../../constants/ebon';
import { ENTERPRISE_CARD } from '../../../../constants/paymentMethods';

import { formatAmountCurrency } from '../../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import './EnterpriseCardStyle.scss';

const EnterpriseCard = ({ selectedMethod, handleMethodChange, cartTotalValue, i18n, balance }) => {
    const isBalanceSufficient = balance >= cartTotalValue;

    const renderEnterpriseCardMessage = () => {
        if (isBalanceSufficient) {
            const remainingBalance = balance - cartTotalValue;
            return convertHtmlToReactDomWithParams(
                i18n.PAYMENT_CHOICE.TEXT_OK,
                ENTERPRISE_CARD_NAME,
                formatAmountCurrency(remainingBalance)
            );
        } else {
            const requiredAmount = cartTotalValue - balance;
            return convertHtmlToReactDomWithParams(
                i18n.PAYMENT_CHOICE.TEXT_KO,
                formatAmountCurrency(requiredAmount),
                ENTERPRISE_CARD_NAME
            );
        }
    };

    return (
        isBalanceSufficient && (
            <div
                id="enterprise-card-container"
                className={`${!isBalanceSufficient ? 'deactivated' : ''}`}
                onClick={() => isBalanceSufficient && handleMethodChange(ENTERPRISE_CARD)}>
                <div className="wrapper">
                    <input
                        type="radio"
                        id="enterprise-card"
                        name="enterprise-card"
                        value={ENTERPRISE_CARD}
                        checked={selectedMethod === ENTERPRISE_CARD}
                    />

                    <label htmlFor="enterprise-card">
                        <span>
                            {convertHtmlToReactDomWithParams(
                                i18n.PAYMENT_CHOICE.LOYALTY_CARD,
                                ENTERPRISE_CARD_NAME
                            )}
                        </span>
                        <span className="balance-container">
                            {convertHtmlToReactDomWithParams(
                                i18n.PAYMENT_CHOICE.BALANCE,
                                formatAmountCurrency(balance)
                            )}
                        </span>
                    </label>
                </div>
                <div className="info">{renderEnterpriseCardMessage()}</div>
            </div>
        )
    );
};

EnterpriseCard.propTypes = {
    selectedMethod: PropTypes.string,
    handleMethodChange: PropTypes.func,
    cartTotalValue: PropTypes.number
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON,
        balance: state.account.balance.credit
    };
};

export default connect(mapStateToProps)(EnterpriseCard);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/EnterpriseCard.js